import { HVAC_ONBOARDING_STEPS } from '../content/hvac';
import type { ProgressData } from '../state/ProgressContext';

/**
 * Which of the six HVAC onboarding steps the rep is on (0-based), or 6 once they are active.
 * Derived only from what the server reports, so leaving and coming back always lands on the same
 * step.
 */
export function hvacOnboardingIndex(progress: ProgressData): number {
  const done = new Set(progress.training.completedStepKeys);
  if (!progress.flags.salesResourcesDone) return 0;
  if (!progress.flags.agreementDone) return 1;
  if (!progress.flags.documentsApproved) return 2;
  if (progress.training.approvedAt) return HVAC_ONBOARDING_STEPS.length;
  if (!['HVAC_PRODUCT', 'HVAC_SELLING', 'HVAC_DEMO'].every((key) => done.has(key))) return 3;
  if (!done.has('HVAC_LEADS_REPORTING')) return 4;
  return 5;
}

export function HvacOnboardingSteps({ progress }: { progress: ProgressData }) {
  const index = hvacOnboardingIndex(progress);
  const waitingOnDocuments = index === 2 && progress.flags.taxFormDone;
  return <section className="card hvac-steps-summary" aria-label="Onboarding progress">
    {index >= HVAC_ONBOARDING_STEPS.length
      ? <strong>Onboarding complete - you are active.</strong>
      : <strong>Onboarding step {index + 1} of {HVAC_ONBOARDING_STEPS.length}: {HVAC_ONBOARDING_STEPS[index]}{waitingOnDocuments ? ' (waiting for Krovance to check your documents)' : ''}</strong>}
    <ol>
      {HVAC_ONBOARDING_STEPS.map((step, stepIndex) => (
        <li key={step} className={stepIndex < index ? 'done' : stepIndex === index ? 'current' : undefined}>
          {stepIndex < index ? '✓ ' : ''}{step}
        </li>
      ))}
    </ol>
    {index < HVAC_ONBOARDING_STEPS.length && <p className="field-help">Your progress is saved. You can leave and come back at any time.</p>}
  </section>;
}
